import { useUnit } from 'effector-react'
import { environment } from '../constants'
import { $premiumLevel, UpdateProgressCooldownValues } from '@/entities/user'
import { PremiumLevel } from '@/entities/user'
import { getCountdownTarget } from '@/shared/util/dateOptions.ts'

type CooldownDates = {
  startDate: Date
  endDate: Date
}

export function useGetLastTimeForCooldown({
  next_steam_update_unlocked,
  next_epic_update_unlocked,
  next_xbox_update_unlocked,
  kind,
}: UpdateProgressCooldownValues & {
  kind: 'scoring' | 'claim' | 'bonus'
}): CooldownDates {
  const premiumLevel = useUnit($premiumLevel)

  const { countdownTarget } = getCountdownTarget([
    next_steam_update_unlocked,
    next_epic_update_unlocked,
    next_xbox_update_unlocked,
  ])

  const now = new Date()

  if (!countdownTarget) return { startDate: now, endDate: now }

  const PT30S = 30 * 1000
  const PT60S = 60 * 1000
  // const TWO_MINUTES = 120 * 1000
  const PT24H = 24 * 60 * 60 * 1000
  const PT12H = 12 * 60 * 60 * 1000

  /*
  STEAM__MIN_UPDATE_PLATINUM_INTERVAL=PT12H
  STEAM__MIN_UPDATE_INTERVAL=PT24H
  STEAM__MIN_UPDATE_PREMIUM_INTERVAL=PT24H
  */
  const nextUpd = new Date(countdownTarget)
  if (environment === 'dev') {
    if (kind == 'scoring') {
      if (premiumLevel === PremiumLevel.PLATINUM)
        return { startDate: new Date(nextUpd.getTime() - PT30S), endDate: nextUpd }
      if (premiumLevel === PremiumLevel.PLUS)
        return { startDate: new Date(nextUpd.getTime() - PT60S), endDate: nextUpd }
      if (premiumLevel === PremiumLevel.UNSUBSCRIBED)
        return { startDate: new Date(nextUpd.getTime() - PT60S), endDate: nextUpd }
    }
  } else {
    if (kind == 'scoring') {
      if (premiumLevel === PremiumLevel.PLATINUM)
        return { startDate: new Date(nextUpd.getTime() - PT12H), endDate: nextUpd }
      if (premiumLevel === PremiumLevel.PLUS)
        return { startDate: new Date(nextUpd.getTime() - PT24H), endDate: nextUpd }
      if (premiumLevel === PremiumLevel.UNSUBSCRIBED)
        return { startDate: new Date(nextUpd.getTime() - PT24H), endDate: nextUpd }
    }
  }
  // no interval defined for this kind — cooldown window has zero width
  return { startDate: nextUpd, endDate: nextUpd }
}
